import { defaultTextSize } from '../defaults';
import { getMobileLineHeightClassName } from '../build-global-css';
import { isPixelValue } from '../line-height-to-px';
import { calculateLineHeightInPx } from '../inject-mobile-line-height-class';
import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getStyleProp } from './css-property-utils';
export var injectMobileLineHeightClass = function (el, props) {
    var pixelValueLineHeight = getLineHeightInPx(el, props);
    if (pixelValueLineHeight) {
        var mobileLineHeight = toMobileFontSize(pixelValueLineHeight);
        el.addClass(getMobileLineHeightClassName(mobileLineHeight));
    }
};
export function getLineHeightInPx(el, props) {
    var lineHeight = getStyleProp(el, 'line-height', props.css) || (props || {}).lineHeight;
    var originalLineHeight = getStyleProp(el, 'original-line-height', props.css) ||
        (props || {}).lineHeight;
    var fontSize = getStyleProp(el, 'font-size', props.css) || (props || {}).fontSize;
    return [
        {
            condition: lineHeight && isPixelValue(lineHeight),
            getLineHeight: function () { return lineHeight; },
        },
        {
            condition: lineHeight && !isPixelValue(lineHeight) && fontSize,
            getLineHeight: function () {
                return calculateLineHeightInPx(lineHeight, fontSize) || defaultTextSize;
            },
        },
        {
            condition: originalLineHeight && fontSize,
            getLineHeight: function () {
                return calculateLineHeightInPx(originalLineHeight, fontSize) ||
                    defaultTextSize;
            },
        },
    ].reduce(function (resultingLineHeight, matcher) {
        if (!resultingLineHeight && matcher.condition) {
            return matcher.getLineHeight();
        }
        return resultingLineHeight;
    }, null);
}
//# sourceMappingURL=inject-mobile-line-height-class.js.map